/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Agents_LeadInputs */

const en_fw_bm_agents_lead = /** @type {(inputs: Fw_Bm_Agents_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share of tasks whose first evidence run passed every acceptance criterion.`)
};

const id_fw_bm_agents_lead = /** @type {(inputs: Fw_Bm_Agents_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porsi task yang bukti pertamanya lolos seluruh kriteria penerimaan.`)
};

/**
* | output |
* | --- |
* | "Share of tasks whose first evidence run passed every acceptance criterion." |
*
* @param {Fw_Bm_Agents_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_agents_lead = /** @type {((inputs?: Fw_Bm_Agents_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Agents_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_agents_lead(inputs)
	return en_fw_bm_agents_lead(inputs)
});